import type { ReactElement } from 'react';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { FeatureFlag, Route } from 'config';

import useCurrentUser from 'hooks/useCurrentUser';

import { Component as CheckIcon } from 'icons/icon-ui--check.svg';
import Header from '../Header';
import MobileNav from '../MobileNav';
import Footer from '../Footer';
import { CookieModal } from '../../../../platform/components/shared/modal/CookieModal';

function SignUp(): ReactElement {
  const { location } = window;
  const { currentUser } = useCurrentUser();
  const isDiversifiedPlansEnabled = currentUser.hasFeatureEnabled(
    FeatureFlag.DIVERSIFIED_PLANS,
  );
  const isCookieBannerEnabled = window.gon?.featureFlags?.isCookieBannerEnabled;

  const [isMobileNavActive, setMobileNavActive] = useState(false);

  const isCheckoutStep = location.pathname.startsWith(Route.SIGNUP_CHECKOUT)
    || location.pathname.startsWith(Route.SIGNUP_CHECKOUT_REDEEM);

  const toggleMobileNav = () => setMobileNavActive(!isMobileNavActive);

  return (
    <>
      <a className="sr-only sr-only-focusable" href="#content">
        Skip to main content
      </a>

      <Header
        isMobileNavActive={isMobileNavActive}
        onMobileNavClick={toggleMobileNav}
      />

      <MobileNav
        isActive={isMobileNavActive}
        onClose={toggleMobileNav}
      />

      <main id="content" aria-label="Main content">
        {!isDiversifiedPlansEnabled && (
          <ol
            className={[
              'c-signup-progress',
              isCheckoutStep ? 'in-checkout' : '',
            ].join(' ')}
          >
            <li className={isCheckoutStep ? 'is-completed' : ''}>
              1 - Select Plan
              {isCheckoutStep && <CheckIcon />}
            </li>
            <li
              className={[
                isCheckoutStep ? 'is-active' : '',
              ].join(' ')}
            >
              2 - Checkout
            </li>
            <li>3 - Pick Meals</li>
          </ol>
        )}

        <Outlet />
      </main>

      <Footer />
      {isCookieBannerEnabled && <CookieModal />}
    </>
  );
}

export default SignUp;
